import React, { useCallback, useEffect, useState } from 'react';
import { InputProps } from 'antd';
import { Form } from 'antd';
import { InputCommon } from './InputCommon';

interface PrefixedInputProps {
  prefix: string;
  maxEditableLength?: number;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  name?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  style?: React.CSSProperties;
  // formItemProps?: Form.ItemProps;
  inputProps?: InputProps & React.ComponentProps<typeof InputCommon>;
}

const PrefixedInput: React.FC<PrefixedInputProps> = ({
  prefix,
  maxEditableLength = 5,
  value,
  onChange,
  placeholder = 'Nhập mã',
  name,
  disabled = false,
  required = false,
  className = '',
  style,
  // formItemProps = {},
  inputProps = {},
}) => {
  const getEditablePart = useCallback(
    (fullValue?: string) => {
      if (!fullValue) return '';
      if (fullValue.startsWith(prefix)) {
        return fullValue.slice(prefix.length);
      }
      return fullValue;
    },
    [prefix],
  );

  const [editablePart, setEditablePart] = useState(getEditablePart(value));

  useEffect(() => {
    setEditablePart(getEditablePart(value));
  }, [value, prefix, getEditablePart]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEditablePart = e.target.value.slice(0, maxEditableLength);
    setEditablePart(newEditablePart);

    if (onChange) {
      onChange(prefix + newEditablePart);
    }
  };
  // If name is provided, wrap in Form.Item
  if (name) {
    return (
      <Form.Item
        name={name}
        rules={required ? [{ required: true, message: 'Trường này là bắt buộc' }] : undefined}
        // {...formItemProps}
      >
        <div className={`flex ${className}`} style={style}>
          <div className='bg-gray-200 max-w-fit border border-[var(--thirdColor)] border-r-0 rounded-l-lg px-2 xl:px-4 xl:py-2 flex items-center font-medium text-gray-700'>
            {prefix}
          </div>
          <InputCommon
            value={editablePart}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={disabled}
            className='rounded-r-lg flex-1'
            maxLength={maxEditableLength}
            radius='none'
            {...inputProps}
          />
        </div>
      </Form.Item>
    );
  }
  // If name is not provided, return a simple input
  return (
    <div className={`flex ${className}`} style={style}>
      <div className='bg-gray-200 min-w-fit border border-[var(--thirdColor)] border-r-0 rounded-l-lg px-2 xl:px-4 flex items-center font-medium text-gray-700'>
        {prefix}
      </div>
      <InputCommon
        value={editablePart}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        className='rounded-r-lg flex-1 '
        maxLength={maxEditableLength}
        radius='none'
        {...inputProps}
      />
    </div>
  );
};

export default PrefixedInput;
